import { useSelector } from 'react-redux';
import { walletsSelector } from './selectors';

export function useWallets() {
  return useSelector(walletsSelector);
}
